export enum TradeInSubaruGtpFlowErrorType {
    API_ERROR = 'TRADE_IN_SUBARU_GTP_FLOW_API_ERROR',
    MILEAGE_ERROR = 'TRADE_IN_SUBARU_GTP_FLOW_MILEAGE_ERROR',
    LEASE_ERROR = 'TRADE_IN_SUBARU_GTP_FLOW_LEASE_ERROR'
}
